import * as React from "react";
import { SVGProps } from "react";
const SvgCameraVideo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.5 14C20 14 22 12 22 9.5S20 5 17.5 5 13 7 13 9.5s2 4.5 4.5 4.5Zm0-7C18.9 7 20 8.1 20 9.5S18.9 12 17.5 12 15 10.9 15 9.5 16.1 7 17.5 7Zm-10 7C10 14 12 12 12 9.5S10 5 7.5 5 3 7 3 9.5 5 14 7.5 14Zm0-7C8.9 7 10 8.1 10 9.5S8.9 12 7.5 12 5 10.9 5 9.5 6.1 7 7.5 7Zm21.244 9.404L28.6 16.3c-.5-.4-1.2-.4-1.9-.2l-4.2 1.8V17c0-1.1-.9-2-2-2h-16c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-.8l4.3 1.7c1 .4 2.2-.1 2.6-1.1.08-.24.096-.416.1-.63V18c0-.642-.252-1.2-.756-1.596ZM20.5 25h-16v-8h16v8Zm7-1-5-2v-2l5-2v6Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCameraVideo;
